import { render } from "./RiskAgreement.vue?vue&type=template&id=77f6c07c"
import script from "./RiskAgreement.vue?vue&type=script&lang=js"
export * from "./RiskAgreement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__